import { node, object } from "prop-types";

import styled from "styled-components/macro";

import NavLink from "./NavLink";

const linkListRowPaddingX = 4;

const LinkListRow = ({ contentRef, children, ...props }) => (
  <NavLink
    paddingX={linkListRowPaddingX}
    paddingY={4}
    borderRadius={16}
    tapScale={0.97}
    {...props}
  >
    <SDiv ref={contentRef}>{children}</SDiv>
  </NavLink>
);

LinkListRow.propTypes = { children: node, contentRef: object };

const SDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 22px;
`;

const LinkListRowsWrapper = styled.div`
  margin-top: ${({ $margin = DEFAULT_WRAPPER_MARGIN }) => $margin}px;
  margin-right: ${({ $margin = DEFAULT_WRAPPER_MARGIN }) => $margin}px;
  margin-bottom: ${({ $margin = DEFAULT_WRAPPER_MARGIN, $marginBottom }) =>
    $marginBottom ?? $margin}px;
  margin-left: ${({ $margin = DEFAULT_WRAPPER_MARGIN }) => $margin}px;
  display: flex;
  gap: 3px;
  flex-direction: column;
`;

const DEFAULT_WRAPPER_MARGIN = 4;

export { LinkListRowsWrapper, linkListRowPaddingX };
export default LinkListRow;
